import { tss } from 'tss-react';

export const useTimeDashboardToggleStyles = tss.create(() => ({
  settingsButtonReact: { margin: 0, marginRight: 12, top: 10 },
  settingsButtonWebApp: { position: 'absolute', right: 24, top: 72 },
}));
